<template>
  <div class="meals-stats">
    <v-progress-linear v-if="loading" indeterminate color="primary" height="2" />

    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="item in tabDefs" :key="item.key">
        <v-icon style="margin-right: 7px">{{ item.icon }}</v-icon>
        {{ item.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" :touchless="true">
      <v-tab-item>
        <div class="px-2 mt-2">
          <meals-meals-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <meals-shifts-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <meals-taken-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <meals-companies-chart :orders="orders" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import reportService from "@/services/report";
import MealsMealsChart from "@/components/statistics/meals/MealsMealsChart.vue";
import MealsShiftsChart from "@/components/statistics/meals/MealsShiftsChart.vue";
import MealsTakenChart from "@/components/statistics/meals/MealsTakenChart.vue";
import MealsCompaniesChart from "@/components/statistics/meals/MealsCompaniesChart.vue";

export default {
  name: "RestaurantMealsStats",
  components: { MealsMealsChart, MealsShiftsChart, MealsTakenChart, MealsCompaniesChart },
  props: {
    date: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      orders: [],
      tab: 0,
    };
  },
  computed: {
    tabDefs() {
      return [
        { key: "meals", icon: "mdi-food", label: this.$t("meal_in_meals") },
        { key: "shifts", icon: "mdi-clock-time-four-outline", label: this.$t("orders_by_shift") },
        { key: "taken", icon: "mdi-check-circle-outline", label: this.$t("ordered_taken_meals") },
        { key: "companies", icon: "mdi-office-building", label: this.$t("companies") },
      ];
    },
  },
  methods: {
    async fetchData() {
      const restaurantId = this.$store.state.restaurant?.id;
      if (!restaurantId || !this.date?.length) return;
      this.loading = true;
      try {
        const from = this.date[0];
        const to = this.date[1] || this.date[0];
        const res = await reportService.getMealsForRestaurant(restaurantId, {
          date: from,
          date2: to,
        });
        this.orders = this.parseOrders(res.data || {});
      } catch {
        this.orders = [];
      } finally {
        this.loading = false;
      }
    },
    // raw: { company: { "1": { mealName: { id, quantity, quantity_payed } } } }
    parseOrders(raw) {
      const result = [];
      for (const company in raw) {
        const shifts = raw[company];
        for (const shiftStr in shifts) {
          const shift = parseInt(shiftStr);
          if (isNaN(shift)) continue;
          const meals = shifts[shiftStr];
          for (const mealName in meals) {
            const meal = meals[mealName];
            result.push({
              company: this.toLatin(company),
              meal: this.toLatin(mealName),
              shift,
              qty: meal.quantity || 0,
              taken: meal.quantity_payed || 0,
            });
          }
        }
      }
      return result;
    },
  },
  watch: {
    date: { handler() { this.fetchData(); }, deep: true },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped>
.meals-stats ::v-deep .v-tabs-items,
.meals-stats ::v-deep .v-window__container,
.meals-stats ::v-deep .v-window-item {
  overflow: visible !important;
}
</style>
